import { memo } from 'react'
import Slideshow from '../slideshow/Slideshow'
import {ReactComponent as IconPlayWithOthers} from '../images/play_with_others.svg';
import {ReactComponent as IconRatings} from '../images/ratings.svg';
import {ReactComponent as IconMistakes} from '../images/mistakes.svg';
import {ReactComponent as IconLessons} from '../images/lessons.svg';

const ContentAnonymous = memo(() => (
  <Slideshow
    slides={[
      {
        className: 'play-with-others',
        text: 'Play checkers online with people at your level with no limits',
        icon: <IconPlayWithOthers/>,
      },
      {
        className: 'ratings',
        text: 'See and improve your checkers ratings',
        icon: <IconRatings/>,
      },
      {
        className: 'mistakes',
        text: 'Check mistakes in your games and see the best move',
        icon: <IconMistakes/>,
      },
      {
        className: 'lessons',
        text: 'Get access to checkers masters lessons',
        icon: <IconLessons/>,
      },
    ]}
  />
))

export default ContentAnonymous
